/**
 * 静态路由
 */

export default [
  {
    path: '/',
    redirect: '/space/index'
  },
  {
    path: '/auth',
    meta: {
      hidden: true,
      title: '认证页'
    },
    component: () => import('@/views/auth.vue')
  },
  {
    path: '/login',
    meta: {
      hidden: true,
      title: '登录'
    },
    component: () => import('@/views/external-login/index.vue')
  },
  {
    path: '/share',
    meta: {
      hidden: true,
      title: '分享页'
    },
    component: () => import('@/views/shareTransfer.vue')
  },
  {
    path: '/external-share',
    meta: {
      hidden: true,
      title: '外部分享页'
    },
    component: () => import('@/views/externalShareTransfer.vue')
  },
  {
    path: '/downloadZip',
    meta: {
      hidden: true,
      title: '下载页'
    },
    component: () => import('@/views/downloadTransfer.vue')
  },
  {
    path: '/visited',
    redirect: '/visited/index',
    meta: {
      sort: 1
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/visited/index',
        meta: {
          title: '最近访问',
          icon: 'history',
          level: 1
        },
        component: () => import('@/views/visited/index.vue')
      }
    ]
  },
  {
    path: '/collect',
    redirect: '/collect/index',
    meta: {
      sort: 3
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/collect/index',
        meta: {
          title: '我的收藏',
          icon: 'collect',
          level: 1
        },
        component: () => import('@/views/collect/index.vue')
      }
    ]
  },
  {
    path: '/public-download',
    redirect: '/public-download',
    meta: {
      hidden: true,
      sort: 7
    },
    component: () => import('@/layoutPublic/index.vue'),
    children: [
      {
        path: '/public-download',
        meta: {
          hidden: true,
          title: '公共下载页'
        },
        component: () => import('@/views/publicDownload/index.vue')
      }
    ]
  },
  {
    path: '/public',
    redirect: '/public',
    meta: {
      hidden: true,
      sort: 6
    },
    component: () => import('@/layoutPublic/index.vue'),
    children: [
      {
        path: '/public',
        meta: {
          hidden: true,
          title: '公共空间'
        },
        component: () => import('@/views/publicSpace/index.vue')
      }
    ]
  }
];
